import Repository from "./Repository";

const GET_AUTHURL = "getAuthURL";
const GET_TOKEN = "getToken";
export default {
  getAuthUrl(payload) {
    return Repository.post(transformRoute(GET_AUTHURL), payload);
  },
  getToken(payload) {
    return Repository.post(transformRoute(GET_TOKEN), payload);
  },
};
const transformRoute = (route) => {
  return `/google/${route}`;
};
